module.exports = __webpack_public_path__ + "img/bgHomeUser.bfc7dde1.png";